import {  Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';


type VATLineProps = {
  calculateVATPercentage: (taxAmount: number | undefined, totalAmount: number) => string;
  currency: string;
  formatPrice: (amount: number, currency: string) => string;
  taxAmount?: number;
  totalAmount: number;
}

export const VATLine = ({ calculateVATPercentage, currency, formatPrice, taxAmount, totalAmount }: VATLineProps) => {
  return (
    <Stack alignItems="center" direction="row" justifyContent="space-between">
      <Typography color="grey.700" variant="body-2">
        VAT {calculateVATPercentage(taxAmount, totalAmount)}
      </Typography>
      <Typography color="grey.700" variant="body-2">
        {taxAmount ? formatPrice(taxAmount, currency) : '$0.00'}
      </Typography>
    </Stack>
  );
};
